"use client";
import { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import ContactSalesModal from "@/components/ContactSalesModal";

const CtaSection = () => {
  const { t } = useTranslation();
  const [salesModalOpen, setSalesModalOpen] = useState(false);

  return (
    <>
    <ContactSalesModal open={salesModalOpen} onOpenChange={setSalesModalOpen} />
    <section className="py-20 md:py-28 bg-secondary/50">
      <div className="container mx-auto px-4 md:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="font-display text-3xl md:text-4xl font-bold text-foreground tracking-tight mb-6"
        >
          {String(t("cta.title"))}{" "}
          <span className="text-primary">{String(t("cta.titleHighlight"))}</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="text-muted-foreground mb-8 text-sm"
        >
          {String(t("cta.subtitle"))}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.25 }}
          className="flex justify-center"
        >
          <Button
            size="lg"
            className="gap-2 font-semibold px-8"
            onClick={() => setSalesModalOpen(true)}
          >
            {String(t("cta.button"))}
            <ArrowRight className="h-4 w-4" />
          </Button>
        </motion.div>
      </div>
    </section>
    </>
  );
};

export default CtaSection;
